import { createNamespacedAction } from '../namespaces'

export const fetchRequest = createNamespacedAction('nautilusApi/FETCH_REQUEST')
export const fetchResponse = createNamespacedAction('nautilusApi/FETCH_RESPONSE')
